import { Space } from 'antd';
import { BusinessList } from 'components/organisms/BusinessList';
import { HomeControls } from 'components/organisms/HomeControls';
import React from 'react';

export const HomePage = (): JSX.Element => {
  return (
    <Space size={16} direction="vertical">
      <HomeControls />
      <BusinessList />
    </Space>
  );
};
